import { render, staticRenderFns } from "./UserInterestsTabs.vue?vue&type=template&id=4bc58698&"
import script from "./UserInterestsTabs.vue?vue&type=script&lang=js&"
export * from "./UserInterestsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports